import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { NotificationEventKey } from "@colab/shared";

// POST /api/settings/notifications/test/:eventKey
//
// Fires the notifications dispatcher with a synthetic payload for the chosen
// event. Worker offloads via executionCtx.waitUntil so the response returns
// before Gmail / Slack fan-out completes. Sub-bucket 19 — invalidates the
// notificationInsights aggregate since the fan-out writes a new
// notification_deliveries row that should show up in the 30-day rollup.
export function useTestSendNotification() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, NotificationEventKey>({
    mutationFn: (eventKey) =>
      apiFetch<{ ok: true }>(`/settings/notifications/test/${eventKey}`, {
        method: "POST",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.settings.notificationInsights(),
      });
      toast.success("Test notification queued — check your inbox + #colab-notifications");
    },
    onError: (err) => {
      toast.error(err.message ?? "Test send failed");
    },
  });
}
